import React from 'react';
import Cookies from 'js-cookie'
import GuitarpartyModal from '../modal'
import { openModal, closeModal } from '../../api/modals/actions'
import { fetchProfile, saveProfile } from '../../api/profile/actions'

import { store } from '../../store'
import { connectWithStore } from '../../utils'

const SURVEY_URL_IS = 'https://forms.gle/5kvWPqUMt291Goqi7'
const SURVEY_URL_EN = 'https://forms.gle/dHJv7BxDffYNZxdR8'
const SURVEY_MODAL_KEY = 'modal-survey'
const SURVEY_STATUS_PREF_KEY = 'surveyModalStatus'
const SURVEY_LAST_PROMPT_PREF_KEY = 'surveyModalLastPromptAt'
const SURVEY_STATUS_COOKIE = 'survey_modal_status'
const SURVEY_LAST_PROMPT_COOKIE = 'survey_modal_last_prompt_at'
const SURVEY_MODAL_END = new Date(2026, 2, 1) // March 1, 2026 (local)
const SURVEY_WAIT_MS = 5 * 24 * 60 * 60 * 1000
const SURVEY_COOKIE_OPTIONS = { expires: 3650, path: '/' }

class ModalSurvey extends React.Component {
    constructor() {
        super();
        this.state = {
            hasRequestedOpen: false,
            hasRequestedProfile: false,
        }

        this.handleTakeSurvey = this.handleTakeSurvey.bind(this)
        this.handleRemindLater = this.handleRemindLater.bind(this)
        this.handleDecline = this.handleDecline.bind(this)
    }

    componentDidMount() {
        this.maybeShowSurvey()
    }

    componentDidUpdate(prevProps) {
        if (this.state.hasRequestedOpen) {
            return
        }

        if (this.props.user !== prevProps.user || this.props.profile !== prevProps.profile) {
            this.maybeShowSurvey()
        }
    }

    parseTimestamp(value) {
        if (value === null || value === undefined || value === '') {
            return null
        }
        const numeric = Number(value)
        if (Number.isFinite(numeric)) {
            return numeric
        }
        const parsed = Date.parse(value)
        return Number.isNaN(parsed) ? null : parsed
    }

    getPreferenceValue(key) {
        if (!this.props.profile || !this.props.profile.ui_preferences) {
            return null
        }
        return this.props.profile.ui_preferences[key]
    }

    getStatusValues() {
        return {
            preference: this.getPreferenceValue(SURVEY_STATUS_PREF_KEY),
            cookie: Cookies.get(SURVEY_STATUS_COOKIE)
        }
    }

    hasFinalStatus() {
        const { preference, cookie } = this.getStatusValues()
        return [preference, cookie].some((status) => status === 'taken' || status === 'denied')
    }

    getLastPromptAt() {
        const preferenceValue = this.getPreferenceValue(SURVEY_LAST_PROMPT_PREF_KEY)
        const preference = this.parseTimestamp(preferenceValue)
        const cookie = this.parseTimestamp(Cookies.get(SURVEY_LAST_PROMPT_COOKIE))

        if (preference === null && cookie === null) {
            return null
        }

        return Math.max(preference || 0, cookie || 0)
    }

    recordPromptAt(timestamp) {
        Cookies.set(SURVEY_LAST_PROMPT_COOKIE, String(timestamp), SURVEY_COOKIE_OPTIONS)
        if (this.props.user && this.props.user.isAuthenticated) {
            this.props.dispatch(saveProfile(SURVEY_LAST_PROMPT_PREF_KEY, timestamp, true))
        }
    }

    recordStatus(status, timestamp) {
        Cookies.set(SURVEY_STATUS_COOKIE, status, SURVEY_COOKIE_OPTIONS)
        if (timestamp) {
            Cookies.set(SURVEY_LAST_PROMPT_COOKIE, String(timestamp), SURVEY_COOKIE_OPTIONS)
        }
        if (this.props.user && this.props.user.isAuthenticated) {
            this.props.dispatch(saveProfile(SURVEY_STATUS_PREF_KEY, status, true))
            if (timestamp) {
                this.props.dispatch(saveProfile(SURVEY_LAST_PROMPT_PREF_KEY, timestamp, true))
            }
        }
    }

    maybeShowSurvey() {
        if (this.state.hasRequestedOpen) {
            return
        }
        if (new Date() >= SURVEY_MODAL_END) {
            return
        }

        const { user, profile } = this.props

        if (user && user.isAuthenticated && profile && !profile.hasFetched) {
            if (!this.state.hasRequestedProfile && !profile.isFetching) {
                this.setState({ hasRequestedProfile: true })
                this.props.dispatch(fetchProfile())
            }
            return
        }

        if (this.hasFinalStatus()) {
            return
        }

        const lastPromptAt = this.getLastPromptAt()
        const now = Date.now()

        if (lastPromptAt !== null && now - lastPromptAt < SURVEY_WAIT_MS) {
            return
        }

        this.recordPromptAt(now)
        this.setState({ hasRequestedOpen: true })
        this.props.dispatch(openModal(SURVEY_MODAL_KEY))
    }

    handleTakeSurvey(url, event) {
        if (event) {
            event.preventDefault()
        }
        const now = Date.now()
        this.recordStatus('taken', now)
        this.props.dispatch(closeModal(SURVEY_MODAL_KEY))
        window.open(url, '_blank', 'noopener,noreferrer')
    }

    handleRemindLater() {
        const now = Date.now()
        this.recordPromptAt(now)
        this.props.dispatch(closeModal(SURVEY_MODAL_KEY))
    }

    handleDecline() {
        const now = Date.now()
        this.recordStatus('denied', now)
        this.props.dispatch(closeModal(SURVEY_MODAL_KEY))
    }

    render() {
        return (
            <GuitarpartyModal extraClasses="modal-survey" modalKey={SURVEY_MODAL_KEY} {...this.props}>
                <button type="button" className="close" data-dismiss="modal" aria-label={gettext('Close')} onClick={this.handleRemindLater}>
                    <span></span>
                    <span></span>
                </button>
                <div className="survey-content">
                    <h2>{gettext('Help us improve Guitarparty')}</h2>
                    <p>{gettext('Take our short survey and help shape the future of Guitarparty.')}</p>
                    <p>{gettext('Two participants will be chosen to win a 1-year subscription.')}</p>
                    <p>{gettext('Choose your preferred language:')}</p>
                    <div className="survey-actions">
                        <button className="btn survey-primary" onClick={(event) => this.handleTakeSurvey(SURVEY_URL_IS, event)}>{gettext('Take the survey in Icelandic')}</button>
                        <button className="btn survey-secondary" onClick={(event) => this.handleTakeSurvey(SURVEY_URL_EN, event)}>{gettext('Take the survey in English')}</button>
                        <button className="btn survey-tertiary" onClick={this.handleRemindLater}>{gettext('Remind me later')}</button>
                        <button className="btn survey-tertiary" onClick={this.handleDecline}>{gettext("I don't want to")}</button>
                    </div>
                </div>
            </GuitarpartyModal>
        )
    }
}

function mapStateToProps(state) {
    var f = {
        modals: {},
        user: {},
        profile: {},
    }

    f.modals = (state.modals === undefined) ? [] : state.modals
    f.user = (state.user === undefined) ? [] : state.user
    f.profile = (state.profile === undefined) ? {} : state.profile

    return f;
}

export default connectWithStore(store, ModalSurvey, mapStateToProps);
